<template>
  <main class="content pb-50 pt-30" style="min-height: 800px;">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <Sidenav />
        </div>
        <div class="col-md-9">
          <h2 class="header-title">My Points</h2>
          <div class="profile-details mt-20">
            <transition name="component-fade" mode="out-in">
              <component
                v-bind:is="currentComponent"
                @change-component="changeComponent"
                @change-title="changeTitle"
                @get-customer-profile="getCustomerProfile"
                :title="title"
              ></component>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery";
import Sidenav from "@/components/layout/Sidenav.vue";
import PointsDetails from "@/components/points/Details.vue";

export default {
  name: "MyPoints",
  components: { Sidenav, PointsDetails },
  data() {
    return {
      currentComponent: "PointsDetails",
      title: ""
    };
  },
  computed: {
    ...mapState("auth", {
      token: state => state.token
    }),
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken
    })
  },
  mounted: () => {
    $("body").css({ backgroundColor: "#f4f5f8" });
  },
  methods: {
    changeComponent(component) {
      this.currentComponent = component;
    },
    changeTitle(title) {
      this.title = title;
    },
    async getCustomerProfile() {
      let request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        }
      };
      await this.$store.dispatch("customer/getCustomerProfile", request);
    }
  }
}
</script>
